<template>
  <div class="mine-pane mine-container" :class="{'ja': $i18n.locale === 'ja'}">
    <div class="mine-wrapper" ref="minePaneRef" @scroll="closeTargetDate">
      <div class="mine-header">
        <div class="type-change-switch">
          <TypeSelector
            :icon-class="['icon--card-list', 'icon--type-of-list' ]"
            :mode-type="['card', 'table']"
            :value="listType"
            @select="onChangeListType"
          />
        </div>
        <div class="history-report-count">{{ $t('mine.header.archivedReport') }}: {{ totalReportCnt }}</div>
        <div class="mine-search-wrap">
          <div v-if="searchedKeyword.length > 0" class="search-count">
              <em>{{ searchResultCnt }}</em>{{ $t('common.searchResult') }}
          </div>
          <div class="searchType-input">
            <button class="search-btn" @click="onSearch">
              <i class="icon icon--search size-16"></i>
            </button>
            <button class="clear-btn" v-show="keyword.length > 0" @click="onClearSearch">
              <i class="icon icon--close14"></i>
            </button>
            <input type="text"
              ref="keyword"
              :placeholder="$t('mine.header.search')"
              v-model="keyword"
              @keydown.enter.prevent="onSearch($event)" />
          </div>
        </div>
      </div>
      <keep-alive v-if="flatReportList.length > 0">
        <MineListCardView
          v-if="listType === 'card'"
          :report-list="reportList"
          :keyword="searchedKeyword"
          @retry="retryGetReport"
          @compare="createCompareReport"
          @onCompare="setReportComparing"
          @setPopup="setPopupData"
        />
        <MineListTableView
          v-else
          :report-list="flatReportList"
          :keyword="searchedKeyword"
          :show-marketing="onPopup"
          @retry="retryGetReport"
          @setPopup="setPopupData"
          @closePopup="closeTargetDate"
          @onSort="onChangeSortby"
        />
      </keep-alive>
      <div v-else-if="searchedKeyword.length || hasFilter" class="no-data">
        <i class="icon loading--empty"></i>
        <p class="no-data-title">{{ $t('common.noResult') }}</p>
        <template v-if="searchedKeyword.length">
          <p class="no-data-description">
            {{ $t('common.noResultSearch') }}
          </p>
          <p class="no-data-keyword">'{{ searchedKeyword }}'</p>
        </template>
      </div>
    </div>
    <div class="compare-date-picker-wrap" :style="{ top: datepickerPosition.y + 'px', left: datepickerPosition.x + 'px' }"
    >
    <!-- @mouseleave="closeTargetDate" -->
      <CompareDatePicker v-if="onCompare"
        :analysisRange="dateRange"
        :maxDays="184"
        :minDate="minSelectedDate"
        :maxDate="maxSelectedDate"
        :minSelectableDate="null"
        :timezone="userData.timezone"
        :timezoneName="userData.timezoneName"
        @onRangeCancel="closeTargetDate"
        @onRangeChange="onRangeChange"
      />
      <div class="marketing-detail-popup" v-if="onPopup" @click.stop="">
        <div class="mine-marketing-detail">
          <template v-if="marketingData.type === 'utm'" >
            <div class="title">UTM Parameter</div>
            <div class="contents">
              <div class="marketing-list" v-for="(value, name) in marketingData.data" :key="name">
                <p class="marketing-list-label">{{ name }}:</p>
                <p class="marketing-list-value">{{ Array.isArray(value) && value.filter(item => item).join(', ') }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="title">{{ marketingData.option.surveyName }}</div>
            <div class="contents">

              <div class="marketing-data-tree" v-if="marketingData.data.notTarget">{{ $t('journey.targeting.survey.step2.notTarget') }}</div>
              <div class="marketing-data-tree">{{ $t('journey.targeting.survey.step2.target') }}</div>

              <div class="marketing-data-tree step-1" v-if="marketingData.data.notAnswered">{{ $t('journey.targeting.survey.step2.notAnswered') }}</div>
              <div class="marketing-data-tree step-1">{{ $t('journey.targeting.survey.step2.answered') }}</div>
              <div class="marketing-data-tree step-2" v-for="(value, name) in marketingData.option.answerOptions" :key="name">
                <div class="marketing-data-tree question"> {{ value.question }}</div>
                  <template v-if="value.questionType === 'range'">
                    <div class="marketing-data-tree answer range">
                      <div class="answer-range-item" v-for="(item, i) in marketingData.data.answerOptions[name]" :key="`answer-${name}-${i}`">{{ item }}</div>
                    </div>
                  </template>
                  <template v-else-if="value.questionType === 'checkbox'">
                    <div class="marketing-data-tree answer checkbox">
                      <div class="answer-checkbox-item" v-for="(item, i) in marketingData.data.answerOptions[name]" :key="`answer-${name}-${i}`">
                        {{ item === 'None' ? $t('trend.other') : value.answerOptions[item] }}
                      </div>
                    </div>
                  </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <Dimmed v-if="setPayment" :close-to-click="true" @close="setPayment = false" >
      <AiReportPayment
        :report-type="upgradeKey"
        :plan-info="getPlan(upgradeKey)[0]"
        :report-name="selectedItem.title"
        :report-info="selectedItem"
        :compare-target="compareTarget"
        @payment="requestPayment" @close="closePayment" @onChargeJam="onChargeJam" />
    </Dimmed>
    <Dimmed v-if="openTossView">
      <CheckoutView class="toss-view"
                    :price="tossPrice"
                    :serviceType="'ba'"
                    :user="userData"
                    :variantKey="variantKey"
                    :product="upgradeKey"
                    @cancelTossPayment="cancelTossPayment"
                    @successTossPayment="successTossPayment"/>
    </Dimmed>

    <dimmed v-if="isChargingJam">
      <charge-pv
          :topUpJam="isChargingJam"
          :remainJam="remainJam"
          @closeLayer="isChargingJam = false" />
    </dimmed>
  </div>
</template>

<script>
import TypeSelector from '@/components/ui/ba/TypeSelector.vue'
import Dimmed from '@/components/ui/Dimmed.vue'
import CheckoutView from '@/components/user-info/manage-plan/CheckoutView.vue'
import AiReportPayment from '@/components/dashboard/AiReportPayment.vue'
import CompareDatePicker from '@/components/mine/CompareDatePicker'
import MineListCardView from './MineListCardView.vue'
import MineListTableView from './MineListTableView.vue'

import { getMineListData, createMineData, getAIReportPlan, retryReport } from '@/api/ai'
import { saveReportPayment } from '@/api/card'
import { mapState } from 'vuex'
import { format, parse, addDays, max } from 'date-fns'
import { convertToTimeZone } from 'date-fns-timezone'
import dummy from '@/data/dummy.json'
import { create } from 'vue-modal-dialogs'
import AppDialog from '@/components/ui/AppDialog'
import ChargePv from '@/components/user-info/manage-plan/ChargePv.vue'
import { REPORT_LINK, MONTHS } from '@/libs/constants'
import { EventBus } from '@/libs/event-bus'
import { getI18n } from '@/libs/i18n'
import { isInIframe } from '@/libs/auth-helper'

const openDialog = create(AppDialog, 'dialogType', 'mashupDate', 'close')

export default {
  name: 'MainPane',
  components: { ChargePv, MineListCardView, MineListTableView, TypeSelector, CompareDatePicker, Dimmed, AiReportPayment, CheckoutView },
  props: {
    mineData: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      reportPaymentId: null,
      reportPaymentType: null,
      isChargingJam: false,
      remainJam: true,
      parentSid: '',
      openTossView: false,
      setPayment: false,
      reportPlan: null,
      upgradeKey: null,
      dummyData: {},
      totalReportCnt: 0,
      searchResultCnt: 0,
      onCompare: false,
      onPopup: false,
      datepickerPosition: {
        x: 0,
        y: 0
      },
      dateRange: {
        starDate: addDays(new Date(), -6),
        endDate: new Date()
      },
      marketingData: {},
      minSelectedDate: null,
      maxSelectedDate: null,
      compareRange: {},
      selectedItem: {},
      reportList: {},
      flatReportList: [],
      aiReportCredit: null,
      isComparing: false,
      compareTarget: null,
      listType: 'card',
      keyword: '',
      searchedKeyword: '',
      mineFilter: {}
    }
  },
  computed: {
    ...mapState([
      'domain',
      'userData',
      'journeyOptions',
      'journeyPeriod',
      'isDemo'
    ]),
    noData () {
      return this.totalReportCnt === 0
    },
    hasFilter () {
      if (!this.mineFilter) return false
      return this.mineFilter.typeList ||
        (this.mineFilter.regDateRange !== null && this.mineFilter.regDateRange !== undefined) ||
        this.mineFilter.startDate ||
        this.mineFilter.endDate
    }
  },
  created () {
    this.parentSid = 's' + this.$route.query.sid
    getAIReportPlan().then(resp => {
      this.reportPlan = resp
    })
    this.getMineList()
    this.dummyData = dummy
    this.setMinMaxDate()
  },
  mounted () {
    EventBus.$on('mineFilterChange', (filter) => {
      this.mineFilter = filter
      this.getMineList(this.searchedKeyword || null)
    })
  },
  beforeDestroy () {
    EventBus.$off('mineFilterChange')
  },
  methods: {
    setReportComparing (value, report = null) {
      this.isComparing = value

      for (let i = 0; i < this.reportList.length; i++) {
        for (let j = 0; j < this.reportList[i].list.length; j++) {
          const item = this.reportList[i].list[j]
          this.$set(this.reportList[i].list[j], 'isComparing', false)
          if (report && item.id === report.id) {
            this.$set(this.reportList[i].list[j], 'isComparing', value)
          }
        }
      }
    },
    onChangeListType (type) {
      this.listType = type
      if (this.isComparing) {
        this.setReportComparing(false)
      }
    },
    onShowReport (reportId, status) {
      if (status === 'ing') {
        return null
      } else {
        window.open(REPORT_LINK + '/' + reportId, isInIframe() ? '_self' : '_blank')
        this.isReportClicking = false
      }
    },
    openTossPayment (variantKey) {
      this.variantKey = variantKey
      this.openTossView = true
    },
    cancelTossPayment () {
      this.openTossView = false
    },
    requestPayment (payload) {
      if (payload.title) {
        this.selectedItem.title = payload.title
      }
      this.selectedItem.lang = payload.lang

      // mashup beta - no payment
      if (payload.paymentType === 'justCard' || payload.paymentType === 'justWire') {
        this.tossPrice = payload.price
        this.openTossPayment(payload.paymentType)
      } else if (payload.paymentType === 'aiReportCredit') {
        const useCredit = true
        if (this.upgradeKey === 'compare') {
          this.createMine('compare', useCredit)
        }
      } else {
        const params = {
          reportType: this.upgradeKey,
          variantKey: payload.paymentType,
          serviceType: 'ba',
          price: payload.paymentType === 'jam' ? payload.price : payload.price * 1.1
        }
        saveReportPayment(params).then(resp => {
          if (resp) {
            this.reportPaymentType = payload.paymentType
            this.reportPaymentId = resp._id
            if (this.upgradeKey === 'compare') {
              this.createMine('compare')
            }
          }
        })
      }
    },
    getMineList (searchText = null) {
      EventBus.$emit('onLoading', true)

      if (this.mineFilter.typeList && !this.mineFilter.typeList.length) {
        this.totalReportCnt = 0
        this.reportList = []
        this.flatReportList = []
        this.ReportListForSort = []
        this.newFlatList = []
        EventBus.$emit('onLoading', false)
        return
      }

      const requestData = {
        parentSid: this.parentSid,
        matchType: this.domain.matchType,
        search: searchText,
        lang: this.$i18n.locale,
        ...this.mineFilter
      }

      getMineListData(requestData, true).then(result => {
        if (!searchText) {
          this.searchedKeyword = ''
          this.totalReportCnt = result.totalLen
        } else {
          this.searchedKeyword = searchText
          this.searchResultCnt = result.totalLen
        }

        this.reportList = Object.entries(result.monthlyList)
          .map(([month, list]) => ({ month, list }))
          .sort((a, b) => b.month.localeCompare(a.month))

        const monthKeys = Object.keys(result.monthlyList).sort((a, b) => b.localeCompare(a))
        this.newFlatList = []

        for (let monthKey of monthKeys) {
          this.newFlatList = [...this.newFlatList, ...result.monthlyList[monthKey]]
        }

        this.flatReportList = this.newFlatList
        this.ReportListForSort = this.createListForSort(this.flatReportList)

        EventBus.$emit('onLoading', false)
      })
    },
    createMine (mode, useCredit = false) {
      if (!this.selectedItem.id) return
      const requestData = {
        reportId: this.selectedItem.id,
        type: this.selectedItem.type,
        isPromptAdvanced: this.selectedItem.isPromptAdvanced,
        promptType: mode === 'compare' ? 'compare' : this.selectedItem.promptType,
        reportPaymentId: this.reportPaymentId,
        reportPaymentType: this.reportPaymentType,
        paid: true,
        title: this.selectedItem.title,
        lang: this.selectedItem.lang || getI18n().locale,
        matchType: this.selectedItem.matchType || 'simple'
      }

      if (mode === 'compare') {
        requestData.compareField = this.compareTarget.name
        requestData.compareValue = this.compareTarget.value
      }

      if (useCredit) {
        requestData.isUseAIReportCredit = true
      }
      createMineData(requestData).then(result => {
        openDialog('report.reportRequest.success')
        this.getMineList()
      }).catch(err => {
        if (err.message === 'sysError') {
          openDialog('report.reportRequest.sysError')
        }
      })
    },
    weeklyDate (report) {
      const weeklyDate = report.weeklyDateStr || ''
      const weeklyDateArr = weeklyDate.split('-')
      const lang = report.lang

      let year = weeklyDateArr[0] || ''
      let month = weeklyDateArr[1] || 1
      let week = weeklyDateArr[2] || ''

      switch (lang) {
        case 'ko':
          return `[${year}년 주간리포트]<br>${month}월 ${week}주차`
        case 'ja':
          return `[第${week}週 週間レポート]<br>${month}月 ${week}週`
        default:
          return `[${year} Weekly Report]<br>${MONTHS[month - 1]}. Week ${week}`
      }
    },
    setPosition (el) {
      const ww = window.innerWidth
      const wh = window.innerHeight
      const elPos = el.getBoundingClientRect()
      const modalSize = this.onCompare ? { w: 575, h: 534 } : { w: 412, h: 270 }
      const offset = 10
      const bottomOver = wh - (elPos.y + modalSize.h)
      const rightOver = ww - (elPos.left + (elPos.width / 2 + modalSize.w / 2))
      return {
        x: elPos.x + (elPos.width / 2) - (modalSize.w / 2) + (rightOver < 0 ? rightOver - offset : 0),
        y: elPos.y + (bottomOver < 0 ? bottomOver - offset : 0)
      }
    },
    setPopupData ({ target: el, data }) {
      this.closeTargetDate()
      let originData = null
      if (data.promptType === 'compare') {
        originData = data.orgList[0]
      } else {
        originData = data.marketing
      }
      const type = originData.utm ? 'utm' : 'survey'
      this.marketingData.type = originData.utm ? 'utm' : 'survey'

      this.marketingData.type = type
      this.marketingData.data = originData[type]
      if (type === 'survey') this.marketingData.option = originData.surveyOption
      document.body.addEventListener('click', this.closeTargetDate, false)

      this.selectedItem = data
      this.onPopup = true
      this.datepickerPosition = this.setPosition(el)
    },
    createCompareReport ({ compareTarget, data }) {
      console.log(compareTarget, data)

      // this.dateRange = {
      //   startDate: parse(data.startDateStr, this.domain.timezoneName),
      //   endDate: parse(data.endDateStr, this.domain.timezoneName)
      // }
      this.selectedItem = data
      this.compareTarget = compareTarget
      this.upgradeKey = 'compare'
      this.checkReport()
    },
    closeTargetDate (value) {
      this.onCompare = false
      this.onPopup = false
      document.body.removeEventListener('click', this.closeTargetDate)
    },
    onRangeChange ({ range }) {
      if (range) {
        this.closeTargetDate()

        this.compareRange.start = format(range.startDate, 'YYYY-MM-DD')
        this.compareRange.end = format(range.endDate, 'YYYY-MM-DD')
        this.upgradeKey = 'compare'
        this.checkReport()
      }
    },
    setRegDate (utcDate) {
      const date = parse(utcDate, this.timezone)
      return format(date, 'YYYY-MM-DD HH:mm:ss')
    },
    getPlan (value) {
      let param
      if (value === 'compare') {
        param = { isPaid: true, promptType: value, reportType: this.selectedItem.reportType }
        if (this.selectedItem.isPromptAdvanced) {
          param.reportType = 'indepth'
        }
      }
      const plan = this.reportPlan.filter(obj =>
        Object.keys(param).every(key => obj[key] === param[key])
      )
      return plan
    },
    successTossPayment (payData) {
      this.reportPaymentType = payData.variantKey
      this.reportPaymentId = payData.paymentId
      this.openTossView = false

      if (this.upgradeKey === 'compare') {
        this.createMine('compare')
      }
    },
    callPayment (value) {
      if (this.getPriceMethod(value)) {
        this.setPayment = !this.setPayment
      } else {
        this.successTossPayment()
      }
    },
    onChargeJam (remainJam) {
      this.closePayment()
      this.remainJam = remainJam
      this.isChargingJam = true
    },
    closePayment () {
      this.setPayment = false
    },
    getPriceMethod (value) {
      const plan = this.getPlan(value)
      return plan[0].price
    },
    setMinMaxDate () {
      const now = new Date()
      let periodMin = convertToTimeZone(max(this.domain.installDate, addDays(now, -397)), { timeZone: this.domain.timezoneName })
      let periodMax = convertToTimeZone(now, { timeZone: this.domain.timezoneName })
      this.minSelectedDate = parse(periodMin, 'YYYY-MM-DD')
      this.maxSelectedDate = parse(periodMax, 'YYYY-MM-DD')
      return {
        minDate: parse(periodMin, 'YYYY-MM-DD'),
        maxDate: parse(periodMax, 'YYYY-MM-DD')
      }
    },
    checkReport () {
      let requestData = {
        checkType: 'mine'
      }
      requestData.reportId = this.selectedItem.id
      requestData.type = this.selectedItem.type
      requestData.isPromptAdvanced = this.selectedItem.isPromptAdvanced
      requestData.promptType = this.upgradeKey === 'compare' ? 'compare' : this.selectedItem.promptType
      requestData.lang = this.selectedItem.lang ? this.selectedItem.lang : getI18n().locale

      if (this.upgradeKey === 'compare') {
        requestData.compareField = this.compareTarget.name
        requestData.compareValue = this.compareTarget.value
      }

      this.callPayment(this.upgradeKey)
    },
    UIDetailFormatDate (value) {
      return format(parse(value), 'YYYY.MM.DD HH:mm:ss')
    },
    retryGetReport (payload) {
      const requestData = {
        reportId: payload.id
      }
      retryReport(requestData)
        .then(res => {
          const { monthIdx, idx, flatIdx } = this.findMine(payload)
          this.reportList[monthIdx].list[idx].isError = false
          this.reportList[monthIdx].list[idx].isReportError = false
          this.reportList[monthIdx].list[idx].reportStatus = 'ing'
          this.flatReportList[flatIdx].isError = false
          this.flatReportList[flatIdx].isReportError = false
          this.flatReportList[flatIdx].reportStatus = 'ing'
          openDialog('report.reportRequest.success')
        })
        .catch(e => {
          console.log('에러')
          console.log(e)
        })
    },
    findMine (report) {
      const head = report.regDate.substr(0, 7)
      const monthIdx = this.reportList.findIndex(item => item.month === head)
      const idx = this.reportList[monthIdx]['list'].findIndex(item => item.id === report.id)
      const flatIdx = this.flatReportList.findIndex(item => item.id === report.id)

      return { monthIdx, idx, flatIdx }
    },
    onSearch (e) {
      if (e && e.isComposing) return
      if (this.isComparing) {
        this.setReportComparing(false)
      }
      this.getMineList(this.keyword)
    },
    onClearSearch () {
      this.keyword = ''
      if (this.searchedKeyword.length > 0) {
        this.getMineList()
      }
    },
    createListForSort (reportList) {
      let listForSort = {}
      reportList.forEach(report => {
        let subReport = report
        if (report.promptType === 'compare' && report.orgList && report.orgList.length > 0) {
          subReport = report.orgList[0]
        } else if (report.promptType === 'mashup' && report.refList && report.refList.length > 0) {
          subReport = report.refList[0].promptType === 'compare' && report.refList[0].orgList.length > 0
            ? report.refList[0].orgList[0] : report.refList[0]
        }

        let marketing = {}

        if (report.promptType === 'compare' && subReport) {
          marketing = { utm: subReport.utm, survey: subReport.survey }
        } else if (report.promptType === 'mashup' && subReport && subReport.marketing) {
          marketing = { utm: subReport.marketing.utm, survey: subReport.marketing.survey }
        } else if (report.marketing) {
          marketing = { utm: report.marketing.utm, survey: report.marketing.survey }
        }

        listForSort[report.id] = {
          regDate: report.promptType === 'mashup' ? subReport.regDate : report.regDate,
          title: report.promptType === 'mashup' ? subReport.title : report.title,
          type: subReport ? subReport.type : report.type,
          domain: subReport ? subReport.domain : report.domain,
          period: subReport ? subReport.startDateStr + subReport.endDateStr : report.startDateStr + report.endDateStr,
          marketing: !marketing.utm ? marketing.survey ? 'Survey' : 'all' : 'UTM Parameter',
          device: subReport ? subReport.device : report.device,
          refer: subReport ? subReport.refer : report.refer,
          exist: subReport ? subReport.exist : report.exist
        }
      })
      return listForSort
    },
    onChangeSortby (criteria) {
      this.flatReportList.sort((a, b) => {
        const aForSort = this.ReportListForSort[a.id][criteria.sortby]
        const bForSort = this.ReportListForSort[b.id][criteria.sortby]
        let valueA = aForSort ? typeof aForSort === 'string' ? aForSort : String(aForSort) : ''
        let valueB = bForSort ? typeof bForSort === 'string' ? bForSort : String(bForSort) : ''

        let result = criteria.direction > 0 ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        if (result === 0) {
          const aRegDate = this.ReportListForSort[a.id].regDate
          const bRegDate = this.ReportListForSort[b.id].regDate
          result = bRegDate.localeCompare(aRegDate)
        }
        return result
      })
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  .ghost {
    position: absolute;
    top: 0;
    right: 100%;
    opacity: .7;
    width: calc(320px * 0.8);
    height: calc(494px * 0.8);
    z-index: -99;
    font-size: 0.8em;
    overflow: hidden;
    .mine-title {
      font-size: clamp(0.8em, 2vw, 1em);
    }
  }
}
$mashupColor: #FF30EA;
$reportColor: #0085FF;
$inDepthColor: #113DAE;
$analyzeColor: #B65EFC;
$reportType: (
  'journey': #8F74FA,
  'target': #8F74FA,
  'ranking': #6289EB,
  'trend': #00A5D9,
  'mashup': #E074E2
);
.mine-container {
  font-size: 14px;
  color: #444;
  font-weight: 500;
  line-height: 1.5;
}
.mine-container * {
  box-sizing: border-box;
}
.mine-pane {
  position: relative;
  height: 100%;
  .mine-wrapper {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .mine-header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 24px 44px;
      .history-report-count {
        flex-grow: 1;
      }
      .mine-search-wrap {
        display: flex;
        align-items: center;
        gap: 16px;
        .search-count {
          font-weight: 400;
          color: #666;
          em {
            font-weight: 500;
            color: #F46200;
          }
        }
        .searchType-input {
          display: flex;
          align-items: center;
          position: relative;
          width: 200px;
          height: 32px;
          &.disabled input{
            background-color: #d7d7d7;
            opacity: 0.3;
            pointer-events: none;
          }
          input {
            width: 100%;
            padding: 9px 10px;
            border: solid 1px transparent;
            border-radius: 5px;
            background: #fff;
            font-size: 13px;
            color: #2F2F2F;
            box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
            box-sizing: border-box;
            &::placeholder {
              color: #BBB;
            }
            &:focus {
              border-color: #0096FF;
            }
          }
          button {
            display: flex;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            &.search-btn {
              right: 6px;
              padding: 2px;
            }
            &.clear-btn {
              right: 32px;
              padding: 3px;
            }
          }
        }
      }
    }

    .no-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .no-data-title {
        font-size: 20px;
        font-weight: 600;
        color: #2f2f2f;
      }

      .no-data-description {
        font-size: 14px;
        line-height: 1.5;
        font-weight: 400;
        color: #767676;
      }

      .no-data-keyword {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.5;
        color: #ff8400;
      }
    }
  }
  //@media screen and (max-width: 1400px) {
  //  .mine-wrapper {
  //    margin-left: 0;
  //    padding: 0 22px 0 235px;
  //  }
  //}
  // no mine data
  .mine-preview-header {
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 30px 32px;
    color: #444;
    font-weight: 600;
    line-height: 1.2;
    .preview-title {
      color: #0085FF;
      font-size: 26px;
    }
    .ai-robot-img {
      width: 70px;
      height: 80px;
      background: url('../../assets/img/mine/ai-robot-hello.svg') no-repeat center;
      background-size: contain;
    }
    .preview-description {
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: 1.5;
    }
  }
  .mine-preview-wrapper {
    display: flex;
    gap: 26px;
    padding: 30px;
    .preview-item {
      position: relative;
      width: 442px;
      height: 625px;
      border-radius: 14px;
      background: #FFF;
      .preview-btn {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);

        display: inline-flex;
        height: 38px;
        min-width: 90px;
        padding: 9px 18px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: 61px;
        background: #0085FF;
        color: #fff;
      }
    }
  }
}
.compare-date-picker-wrap {
  position: fixed;
  z-index: 9999;

  // transform: translate(-50%, -34px);
  .marketing-detail-popup {
    position: relative;
    width: 412px;
    height: 270px;
    overflow-y: auto;
    background-color: #fff;
    box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
    z-index: 110;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.16);
    padding: 20px 0;
    margin-top: 25px;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 20px;
      width: 100%;
      height: 12px;
      z-index: 100;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }

    .mine-marketing-detail {
      height: 100%;
      overflow-y: auto;
      color: #444;
      padding: 0 20px;
      .title {
        color: #444;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        margin-bottom: 16px;
      }
      .contents {
        .marketing-list {
          display: flex;
          gap: 8px;
          color: #666;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.5;
          &-label {
            flex-shrink: 0;
            width: 62px;
          }
        }
        .marketing-data-tree {
          position: relative;
          color: #666;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.5;
          padding: 5px 0;
          &.step-1 {
            margin-left: 15px;
          }
          &.step-2 {
            margin-left: 25px;
          }
          &.step-1:before, &.step-2:before, &.checkbox > div:before {
            content: '';
            position: absolute;
            top: 12px;
            left: -15px;
            width: 6px;
            height: 6px;
            border: 1px solid #979797;
            border-radius: 2px;
            border-top-width: 0;
            border-right-width: 0;
          }
          &.checkbox > div, &.range {
            position: relative;
            padding: 5px 0;
            &:before {
              transform: rotate(-135deg) translate(3px);
            }
          }
          &.answer {
            margin-left: 18px;
            gap: 10px;
          }
          &.range {
            display: flex;
            gap: 5px;

            &> div {
              width: 25px;
              height: 25px;
              text-align: center;
              padding: 5px;
              line-height: 1;
              border-radius: 4px;
              border: 1px solid #979797;
            }

          }
        }
      }
    }
  }
}
</style>
